import type { GTMEventReturnType, GA4ImageNavigationDirection } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMOverviewImageNavigationModelReturnType extends GTMEventReturnType {
    click_text: GA4ImageNavigationDirection;
}

interface GTMOverviewImageNavigationModelData {
    direction: GA4ImageNavigationDirection;
}

export default class GTMOverviewImageNavigationModel extends GTMBaseModel {
    public static parseToGTMData({
        direction
    }: GTMOverviewImageNavigationModelData): GTMOverviewImageNavigationModelReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'overview_image_navigation',
            click_text: direction
        };
    }
}
